export default __webpack_public_path__ + "static/media/crossDisable.dac681b8.svg";